import { useState } from "react";
import axios from "axios";

function PremiumBadgeButton() {
  const [loading, setLoading] = useState(false);
  const token = localStorage.getItem("token");
  const BASE_URL = window.location.hostname === "localhost" ? "http://localhost:5000" : "https://success-blog-app-backend.onrender.com";

  const handlePremium = async () => {
    setLoading(true);
    try {
      const { data } = await axios.post(`${BASE_URL}/api/payment/create-order`, {}, { headers: { Authorization: `Bearer ${token}` } });
      alert("Order Created: " + data.orderId);
      // Razorpay code akkada add chey
    } catch (err) {
      alert(err.response?.data?.message || "Payment Error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{maxWidth: "450px", margin: "40px auto", padding: "24px", borderRadius: "16px", background: "linear-gradient(135deg, #92400e 0%, #f59e0b 100%)", color: "white"}}>
      <h2>⭐ Get Premium Badge</h2>
      <p>Unlock premium identity for 30 days</p>
      <h1>₹1 <span style={{fontSize: "16px"}}>/ 30 days</span></h1>
      <button onClick={handlePremium} disabled={loading} style={{width: "100%", padding: "14px", border: "none", borderRadius: "10px", background: "#fef3c7", color: "#92400e", fontWeight: "800", cursor: "pointer"}}>
        {loading ? "Processing..." : "Get Premium Badge"}
      </button>
    </div>
  );
}
export default PremiumBadgeButton;